import React from 'react';
import './QuestionUploadResultPage.css';

function QuestionUploadResultPage({ statistics, errors, onClose }) {
  const { added = 0, skipped = 0 } = statistics || {};

  return (
    <div className="question-upload-result-page">
      <div className="page-header">
        <button className="back-button" onClick={onClose}>
          ← Geri Dön
        </button>
        <h2>Soru Yükleme Sonuçları</h2>
      </div>
      
      <div className="page-content">
        <div className="question-upload-message">
          <p className="success-message">
            {added} soru başarıyla eklendi!
          </p>
          {skipped > 0 && (
            <p className="skipped-message">
              {skipped} soru atlandı.
            </p>
          )}
        </div>

        {errors && errors.length > 0 && (
          <div className="question-upload-errors">
            <h3 className="errors-title">Hatalar:</h3>
            <ul className="errors-list">
              {errors.slice(0, 5).map((error, index) => (
                <li key={index} className="error-item">
                  {error}
                </li>
              ))}
              {errors.length > 5 && (
                <li className="error-item more-errors">
                  ... ve {errors.length - 5} hata daha
                </li>
              )}
            </ul>
          </div>
        )}

        <div className="page-actions">
          <button
            className="btn btn-primary"
            onClick={onClose}
          >
            Tamam
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuestionUploadResultPage;

